(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pl--open-cart-button"] && !Shopify.designMode) return;
  try {
    class PlOpenCartButton extends HTMLElement {
    constructor() {
      super()
      this.countElement = this.querySelector('.pl-open-cart-button__items-count p')
      this.badgeElement = this.querySelector('.pl-open-cart-button__items-count')

      // Bind context
      this.handleCountUpdate = this.handleCountUpdate.bind(this)
    }

    connectedCallback() {
      document.addEventListener('cart:count-updated', this.handleCountUpdate)
    }

    disconnectedCallback() {
      document.removeEventListener('cart:count-updated', this.handleCountUpdate)
    }

    handleCountUpdate(event) {
      const count = event.detail.count

      // Update badge visibility
      if (count > 0) {
        if (!this.badgeElement) {
          // Create badge if it doesn't exist (was 0 on load)
          const badge = document.createElement('div')
          badge.className = 'pl-open-cart-button__items-count'
          badge.innerHTML = '<p></p>'
          this.querySelector('div[style*="position: relative"]').appendChild(badge)
          this.badgeElement = badge
          this.countElement = badge.querySelector('p')
        }
        this.badgeElement.style.display = 'flex'
      } else {
        if (this.badgeElement) {
          this.badgeElement.style.display = 'none'
        }
        return
      }

      // Update text with truncation logic
      if (this.countElement) {
        if (count > 99) {
          const countStr = count.toString()
          this.countElement.textContent = countStr.slice(0, 2) + '..'
        } else {
          this.countElement.textContent = count
        }
      }
    }
  }

  if (!customElements.get('pl-open-cart-button')) {
    customElements.define('pl-open-cart-button', PlOpenCartButton)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pl--accordion"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pl--accordion__trigger').forEach((button) => {
    const panel = button.nextElementSibling

    // Open by default if specified
    if (button.dataset.open === 'true') {
      button.classList.add('active')
      button.setAttribute('aria-expanded', 'true')
      panel.style.maxHeight = panel.scrollHeight + 'px'
    }

    button.addEventListener('click', function () {
      this.classList.toggle('active')
      const isExpanded = this.getAttribute('aria-expanded') === 'true'

      // Toggle aria-expanded
      this.setAttribute('aria-expanded', !isExpanded)

      if (panel.style.maxHeight && panel.style.maxHeight !== '0px') {
        panel.style.maxHeight = '0px'
        panel.classList.remove('active')
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px'
        panel.classList.add('active')
      }
    })
  })
  } catch(e) { console.error(e); }
})();

})();
